// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const terapagos_stellar: PokeData = {
  "id": 10277,
  "name": "terapagos-stellar",
  "height": 17,
  "weight": 770,
  "base_experience": 90,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "headbutt",
    "double-edge",
    "withdraw",
    "tri-attack",
    "protect",
    "rapid-spin",
    "ancient-power",
    "gyro-ball",
    "rock-polish",
    "earth-power",
    "heavy-slam",
    "tera-starstorm"
  ],
  "moves": [
    "headbutt",
    "tri-attack",
    "protect",
    "ancient-power",
    "earth-power",
    "tackle",
    "scratch",
    "splash",
    "scary-face",
    "leer",
    "supersonic",
    "body-slam",
    "purification"
  ],
  "evolution_chain": {
    "id": 548,
    "item": null,
    "species": [
      {
        "name": "terapagos",
        "order": 1026,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 154,
    "speed": 97,
    "ability_power": 149
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
